
import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic here
    console.log('Form submitted:', formData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const contactInfo = [
    {
      icon: 'ri-mail-line',
      title: 'Email',
      value: 'hello@marketpro.com',
      link: 'mailto:hello@marketpro.com'
    },
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      value: '+1 (234) 567-890',
      link: 'tel:+1234567890'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Office',
      value: 'San Francisco, CA',
      link: '#'
    }
  ];

  const services = [
    'Brand Strategy',
    'Social Media Marketing',
    'Content Marketing',
    'SEO & Analytics',
    'Email Marketing',
    'Paid Advertising'
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 lg:px-12 bg-[#FAFAF9]">
        <div className="max-w-7xl mx-auto text-center">
          <div className="text-xs uppercase tracking-[0.2em] text-[#093a3e] font-bold mb-4">
            GET IN TOUCH
          </div>
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
            Ready to Close Your Diabetic Eye Exam Gaps?
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto">
            Let's discuss how Kinra can improve your screening rates.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-24 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Contact Form */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">
                Send Us a Message
              </h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                    Your Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-6 py-4 rounded-xl border border-gray-200 focus:outline-none focus:border-[#093a3e] text-[15px]"
                    placeholder="John Doe"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-6 py-4 rounded-xl border border-gray-200 focus:outline-none focus:border-[#093a3e] text-[15px]"
                    placeholder="john@company.com"
                  />
                </div>

                <div>
                  <label htmlFor="company" className="block text-sm font-semibold text-gray-700 mb-2">
                    Company Name *
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    required
                    value={formData.company}
                    onChange={handleChange}
                    className="w-full px-6 py-4 rounded-xl border border-gray-200 focus:outline-none focus:border-[#093a3e] text-[15px]"
                    placeholder="Your Company"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-6 py-4 rounded-xl border border-gray-200 focus:outline-none focus:border-[#093a3e] text-[15px]"
                    placeholder="+1 (234) 567-890"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">
                    Tell Us About Your Project *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows={6}
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-6 py-4 rounded-xl border border-gray-200 focus:outline-none focus:border-[#093a3e] text-[15px] resize-none"
                    placeholder="Share your goals, challenges, and what you're looking to achieve..."
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-gray-900 text-white px-8 py-4 rounded-full hover:bg-[#093a3e] transition-all cursor-pointer whitespace-nowrap font-semibold text-lg"
                >
                  Send Message
                </button>
              </form>
            </div>

            {/* Contact Info & Services */}
            <div className="space-y-12">
              {/* Contact Info Cards */}
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  Contact Information
                </h3>
                <div className="space-y-4">
                  {contactInfo.map((info, index) => (
                    <a
                      key={index}
                      href={info.link}
                      className="flex items-center gap-4 p-6 bg-[#FAFAF9] rounded-2xl hover:shadow-lg transition-shadow cursor-pointer"
                    >
                      <div className="w-12 h-12 bg-gradient-to-br from-[#093a3e] to-[#062b2f] rounded-xl flex items-center justify-center">
                        <i className={`${info.icon} text-xl text-white`}></i>
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-gray-500 mb-1">
                          {info.title}
                        </div>
                        <div className="text-gray-900 font-medium">
                          {info.value}
                        </div>
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
